// extracted by mini-css-extract-plugin
export default {"footer_main_input_container":"Gt","footer_input_title":"Ht","footer_input_container":"It","footer_input":"Jt","footer_input_btn":"Kt","footer_main_input_container_mob":"Lt","footer_input_btn_disabled":"Mt"};
    if(module.hot) {
      // 1721922359669
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  